<form class="card mt-3" [formGroup]="form">
    <div *ngIf="action === 'new' || action === 'edit' || action === 'new_capa' || action === 'new_alert' || action === 'edit_alert' ">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
            <div class="m-1 d-flex align-items-center flex-column flex-sm-row">
                <h2 class="m-0 mr-2">
                    {{title}}
                </h2>
                <small class="title-description">
                    Digite todos los campos
                </small>
            </div>
        </div>
    </div>

    <div class="card-body row justify-content-center py-0" *ngIf="action === 'new' || action === 'edit'">
        <mat-form-field appearance="outline" class="col-12 col-md-3" *ngIf="action=='new'">
            <mat-label>Código poligono</mat-label>
            <input matInput formControlName="cod_poligono" type="text" [maxlength]="500"
                (keypress)="onlyAlphanumeric($event)" (paste)="onPaste($event)" (input)="toUpperCaseCode($event)">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-12 col-md-3">
            <mat-label>Nombre poligono</mat-label>
            <input matInput formControlName="nom_poligono" type="text" [maxlength]="500" (input)="toUpperCase($event)">
        </mat-form-field>
        <!-- <mat-form-field appearance="outline" class="col-12 col-md-3" >
                <mat-label>Tipo</mat-label>
                <mat-select formControlName="type" readonly>
                    <mat-option value="E">Existe producto padre</mat-option>
                    <mat-option value="I">No existe producto padre</mat-option>
                </mat-select>
            </mat-form-field> -->
        <mat-form-field appearance="outline" class="col-12 col-md-3">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="estado_legible">
                <mat-option value='A'>Activo</mat-option>
                <mat-option value='I'>Inactivo</mat-option>
            </mat-select>
        </mat-form-field>
        <!-- <mat-form-field appearance="outline" class="col-12 col-md-3" >
                <mat-label>Tipo de caso</mat-label>
                <mat-select formControlName="case" readonly>
                    <mat-option value="2">Caso 2</mat-option>
                    <mat-option value="3">Caso 3</mat-option>
                    <mat-option value="4">Caso 4</mat-option>
                </mat-select>
            </mat-form-field> -->

    </div>

    <!-- DEPARTAMENTO -->
    <div class="selector-card" *ngIf="action === 'departamento'">
        <div class="selector-header">
            <mat-icon>info</mat-icon> Departamentos
        </div>
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>Buscar departamento</mat-label>
            <input matInput [(ngModel)]="filtroDepartamento" name="filtroDepartamento"
                [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <div class="selector-list scrollable">
            <div *ngFor="let depto of departamentosFiltrados" class="selector-item">
                <mat-checkbox [checked]="isDepartamentoSelected(depto)" (change)="toggleDepartamento(depto)">
                </mat-checkbox>
                <span class="selector-label">{{depto.NOMBRE_DEPARTAMENTO}}</span>
            </div>
        </div>
    </div>

    <!-- MUNICIPIO -->
    <div class="selector-card" *ngIf="action === 'municipio'">
        <div class="selector-header">
            <mat-icon>location_city</mat-icon> Municipios
        </div>
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>Buscar municipio</mat-label>
            <input matInput [(ngModel)]="filtroMunicipio" name="filtroMunicipio" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <div class="selector-list scrollable">
            <div *ngFor="let mun of municipiosFiltrados" class="selector-item">
                <mat-checkbox [checked]="isMunicipioSelected(mun)" (change)="toggleMunicipio(mun)">
                </mat-checkbox>
                <span class="selector-label">{{mun.NOMBRE_MUNICIPIO}} ({{mun.CODIGO_DEPARTAMENTO}})</span>
            </div>
        </div>
    </div>

    <!-- ZONA -->
    <div class="selector-card" *ngIf="action === 'zona'">
        <div class="selector-header">
            <mat-icon>map</mat-icon> Zonas
        </div>
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>Buscar zona</mat-label>
            <input matInput [(ngModel)]="filtroZona" name="filtroZona" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <div class="selector-list scrollable">
            <div *ngFor="let zona of zonasFiltrados" class="selector-item">
                <mat-checkbox [checked]="isZonaSelected(zona)" (change)="toggleZona(zona)">
                </mat-checkbox>
                <span class="selector-label">{{zona.NOMBRE_ZONA}} ({{zona.CODIGO_DEPARTAMENTO}}) -
                    ({{zona.CODIGO_MUNICIPIO}})</span>
            </div>
        </div>
    </div>

    <div class="card-body row justify-content-center py-0" *ngIf="action === 'new_capa'">
        <div class="container-option w-100">
            <!-- Checkbox Capacidad por día - AL PRINCIPIO -->
            <div class="row mb-3">
                <div class="col-12">
                    <div class="d-flex align-items-center p-3 border rounded" style="background-color: #f8f9fa;">
                        <mat-checkbox [(ngModel)]="capacidadPorDia" [ngModelOptions]="{standalone: true}" (change)="onCapacidadPorDiaChange($event)" class="me-3">
                            <span class="text-muted ms-2" style="font-size: 14px;">Selecciona esta opción para configurar capacidades específicas por días seleccionados</span>
                        </mat-checkbox>
                    </div>
                </div>
            </div>

            <!-- Campo de fechas múltiples -->
            <div class="row mb-3" *ngIf="capacidadPorDia">
                <div class="col-12">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Seleccionar fechas específicas</mat-label>
                        <mat-chip-list #chipList>
                            <mat-chip *ngFor="let fecha of fechasSeleccionadas" [removable]="true" (removed)="removerFecha(fecha)" color="primary" selected>
                                {{fecha | date:'dd/MM/yyyy'}}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip>
                            <input placeholder="Haz clic en el calendario para agregar fechas" 
                                   [matDatepicker]="picker" 
                                   [matChipInputFor]="chipList"
                                   (dateChange)="agregarFecha($event)"
                                   readonly>
                        </mat-chip-list>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker (closed)="onDatepickerClosed()" touchUi="false"></mat-datepicker>
                        <button mat-icon-button matSuffix type="button" (click)="cerrarCalendario()" *ngIf="calendarioAbierto" matTooltip="Cerrar calendario">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <div class="mt-2">
                        <div class="text-info small" *ngIf="fechasSeleccionadas.length > 0">
                            <mat-icon class="me-1" style="font-size: 16px; vertical-align: middle;">info</mat-icon>
                            Se crearán {{fechasSeleccionadas.length}} registros de capacidad, uno por cada fecha seleccionada
                        </div>
                        <div class="text-muted small mt-1" *ngIf="capacidadPorDia">
                            <mat-icon class="me-1" style="font-size: 14px; vertical-align: middle;">help_outline</mat-icon>
                            El calendario permanece abierto para seleccionar múltiples fechas. Usa el botón X para cerrarlo.
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-2">
                <!-- Código Bodega -->
                <div class="col-md-8">
                    <mat-form-field appearance="outline" class="w-100" style="height: 65px;">
                        <mat-label style="font-family: 'Lato';">Código Bodega</mat-label>
                        <input type="text" matInput [formControl]="filtroBodega" [matAutocomplete]="auto"
                            placeholder="Buscar bodega">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayBodega"
                            (optionSelected)="onBodegaSelected($event)">
                            <mat-option *ngFor="let bodega of bodegasFiltradas | async" [value]="bodega">
                                {{bodega.cod}} - {{bodega.nombre}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <!-- Cierre automático (toggle) -->
                <div class="col-md-4 d-flex align-items-center">
                    <mat-slide-toggle [checked]="cierre_automatico === 'S'" (change)="toggleCierreAutomatico($event)">
                        Cierre automático
                    </mat-slide-toggle>
                </div>
            </div>

            <div class="row">
                <!-- Campos más pequeños en una fila -->
                <div class="col-md-3" *ngIf="cierre_automatico === 'S'">
                    <mat-form-field appearance="outline" class="w-100" style="height: 65px;">
                        <mat-label style="font-family: 'Lato';">% Cierre</mat-label>
                        <input formControlName="porcentaje_cierre" matInput placeholder="Ej: 80"
                            (keypress)="onlyInteger($event)" (paste)="onIntegerPaste($event, 'porcentaje_cierre')">
                    </mat-form-field>
                </div>

                <div class="col-md-3">
                    <mat-form-field appearance="outline" class="w-100" style="height: 65px;">
                        <mat-label style="font-family: 'Lato';">Cubicaje</mat-label>
                        <input formControlName="cubicaje" matInput placeholder="Ej: 123.45"
                            (keypress)="onlyDecimal($event)" (paste)="onDecimalPaste($event)">
                    </mat-form-field>
                </div>

                <div class="col-md-3">
                    <mat-form-field appearance="outline" class="w-100" style="height: 65px;">
                        <mat-label style="font-family: 'Lato';">Cantidad OPS</mat-label>
                        <input formControlName="cantidad_ops" matInput placeholder="Ej: 4"
                            (keypress)="onlyInteger($event)" (paste)="onIntegerPaste($event, 'cantidad_ops')">
                    </mat-form-field>
                </div>
            </div>
        </div>

    </div>

    <div class="card-body row justify-content-center py-0" *ngIf="action === 'new_alert' || action === 'edit_alert'">
        <div class="container-option w-100">

            <div class="row">
                <!-- Campos más pequeños en una fila -->
                <div class="col-md-3">
                    <mat-form-field appearance="outline" class="w-100" style="height: 65px;">
                        <mat-label style="font-family: 'Lato';">% Avance</mat-label>
                        <input formControlName="PORC_AVANCE" matInput placeholder="Ej: 80"
                            (keypress)="onlyInteger($event)" (paste)="onIntegerPaste($event, 'PORC_AVANCE')">
                    </mat-form-field>
                </div>

                <div class="col-md-3">
                    <mat-form-field appearance="outline" class="w-100" style="height: 65px;">
                        <mat-label style="font-family: 'Lato';">Asunto</mat-label>
                        <input matInput formControlName="ASUNTO" type="text" [maxlength]="500"
                            (input)="toUpperCase($event)">
                    </mat-form-field>
                </div>

                <div class="col-md-3">
                    <mat-form-field appearance="outline" class="w-100" style="height: 65px;">
                        <mat-label style="font-family: 'Lato';">Destinatario</mat-label>
                        <input matInput formControlName="DESTINATARIOS" type="text" [maxlength]="500"
                            (input)="toUpperCase($event)">
                    </mat-form-field>
                </div>

            </div>
        </div>

    </div>



    <div *ngIf="action === 'delete'">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
            <div class="m-1 d-flex align-items-center flex-column flex-sm-row">

                <h2 class="m-0 mr-2">
                    {{title}}
                </h2>
                <small class="title-description">
                    Desea {{data.ESTADO_LEGIBLE=='Activo' ? "inactivar" : "activar"}} el poligono <span
                        class="span_style">{{data.COD_POLIGONO}}</span>?
                </small>

            </div>
        </div>
    </div>

    <div *ngIf="action === 'estado_alert'">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
            <div class="m-1 d-flex align-items-center flex-column flex-sm-row">

                <h2 class="m-0 mr-2">
                    {{title}}
                </h2>
                <small class="title-description">
                    Desea {{data.ESTADO=='A' ? "inactivar" : "activar"}} la alerta <span
                        class="span_style">{{data.ID_ALERT}}</span> ?
                </small>

            </div>
        </div>
    </div>

    <div class="card-footer d-flex align-items-center justify-content-end gap-2">
        <button mat-flat-button class="btn_cancel" type="button" (click)="dialogClose()">Cancelar</button>
        <button mat-flat-button type="button" (click)="create()" class="btn_save">{{actions[action]}}</button>

    </div>
</form>